import * as React from 'react';

const closeBtnIcon = (<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M2 16L16 2M16 16L2 2" stroke="#56B2FF" strokeWidth="3"/>
</svg>);

export default closeBtnIcon;
